import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import PodsUsersTable from './PodsUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyPodsUsers } from './companyPodsApi';

/**
 * Company Shoorah Pods → Employees/Members list.
 * Every user of the current population appears (never-listened ones with
 * dashes, sorted last); a row opens their pods profile.
 */
const CPodsUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyPodsUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shoorah Pods — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and their pod listening. Open a user to see
        their full pods profile.
      </p>

      <PodsUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/shoorah-pods/user?userId=${rowData?._id}`)}
        tableName="company_pods_users"
      />
    </div>
  );
};

export default CPodsUsers;
